import winkImg from 'assets/wink.png';
import React, { useEffect, useState } from 'react';
import Button from '../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import './CreateOrExtendProgressBar.scss';
import { Link } from 'react-router-dom';

const fakeResources = [
  'Preparing to copy',
  'Copying dialogues',
  'Copying pages',
  'Copying widgets',
  'Copying other resources',
  'Verifying results',
  'Almost there',
];

type Props = {
  isDone: boolean;
  onClickEndLink?: string;
  onClick: () => any;
};

export const CreateOrExtendProgressBar = ({
  isDone,
  onClick,
  onClickEndLink,
}: Props) => {
  const [currentResource, setCurrentResource] = useState(0);

  useEffect(() => {
    let interval: number;
    const doStep = () => {
      if (isDone) {
        return clearTimeout(interval);
      }
      const newCounter =
        currentResource < fakeResources.length - 1
          ? currentResource + 1
          : fakeResources.length - 1;
      setCurrentResource(newCounter);

      interval = window.setTimeout(
        doStep,
        Math.floor(Math.random() * 4000) + 1000,
      );
    };

    doStep();
    return () => clearTimeout(interval);
  }, []);

  const doneMessage = `Congrats! The Template you chose is finished copying to your Chatbot.
      Now just customize it to suit your Facebook Page!`;

  return (
    <div
      className={`create-or-extend-bot-progress-bar create-or-extend-bot-progress-bar_${isDone}`}
    >
      <img className="create-or-extend-bot-progress-bar__img" src={winkImg} />
      <div className="create-or-extend-bot-progress-bar__title">
        {isDone ? (
          <span>{doneMessage}</span>
        ) : (
          <span>
            Our monkeys are copying the contents of the template you've chosen.
            This may take some time.
          </span>
        )}
      </div>
      {!isDone ? (
        <div className="create-or-extend-bot-progress-bar__text">
          {fakeResources[currentResource]}
        </div>
      ) : (
        <div className="create-or-extend-bot-progress-bar__actions">
          {onClickEndLink ? (
            <Link to={onClickEndLink} className="chatbot-row__action">
              <Button blue onClick={onClick}>
                Take me there
              </Button>
            </Link>
          ) : (
            <Button blue onClick={onClick}>
              Take me there
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
